<ng-container *ngIf="!loadingInitialData && showEmptyState$.value">
    <button-spacer *ngIf="!isDashboardCard" size="lg"></button-spacer>
    <app-empty-state [subDirectory]="isDashboardCard ? 'card' : null"
                     [icon]="isDashboardCard ? 'notification' : null">
        <span emptyStateTitle>{{ 'No notifications yet' }}</span>
        <span emptyStateText>{{ 'Your notifications will appear here once received' }}</span>
    </app-empty-state>
</ng-container>

<mat-selection-list multiple="false"
                    [class.mobile-selection]="mobileMode$ | async"
                    [loadingList]="loadingInitialData && isDashboardCard"
                    [loadingLines]="3"
                    (selectionChange)="handleNotificationClick($event.source.selectedOptions.selected[0].value)">
    <cdk-virtual-scroll-viewport *ngIf="!loadingInitialData" [itemSize]="isDashboardCard ? 86 : 180" [style.height.px]="viewportHeight">
        <ng-container *cdkVirtualFor="let notification of notifications$ | async">
            <mat-list-option [style.height.px]="isDashboardCard ? 86 : 180"
                             [style.width.px]="viewportWidth"
                             [value]="notification" disableRipple>
                <app-avatar-block *ngIf="notification.data"
                                  [iconImage]="notification.data.icon ?? null"
                                  [svgIcon]="notification.data.icon ? null : 'v2:fi-br-question'"
                                  [wrappedText]="!isDashboardCard"
                                  [inVirtualScroll]="true"
                                  matListItemTitle>
                    <mat-icon *ngIf="!notification.readAt" unreadDot>circle</mat-icon>
                    <a *ngIf="context === notificationContexts.PMC"
                       [routerLink]="[notification.data.pmcLink, 'details']"
                       avatarTitle
                       preventClick>
                        {{ notification.data.title }}
                    </a>
                    <a *ngIf="context === notificationContexts.ORGANIZATION"
                       [routerLink]="[notification.data.orgLink, 'details']"
                       avatarTitle
                       preventClick>
                        {{ notification.data.title }}
                    </a>
                    <span avatarDescription>{{ notification.data.organizationName }}</span>
                    <span *ngIf="isDashboardCard && (mobileMode$ | async)" avatarDescription secondary="true">
                        {{ notification.createdAt | legfiDate: 'MM/DD' }}
                    </span>
                    <ng-container *ngIf="!isDashboardCard">
                        <span avatarDescription secondary="true">
                            {{ notification.createdAt | legfiDate: 'MM/DD/YYYY h:mm a' }}
                            <mat-divider></mat-divider>
                            <span *ngIf="!(mobileMode$ | async)" [innerHTML]="notification.data.description | truncate"></span>
                            <span *ngIf="mobileMode$ | async" [innerHTML]="notification.data.description | truncate: 35"></span>
                        </span>
                    </ng-container>
                </app-avatar-block>

                <mat-toolbar *ngIf="!isDashboardCard" class="notification-actions" matListItemMeta>
                    <button mat-flat-button disableRipple preventClick
                            color="accent"
                            (click)="deleteNotifications([notification.id])">
                        <mat-icon [svgIcon]="'v2:fi-br-trash'"></mat-icon>
                    </button>
                </mat-toolbar>
                <span *ngIf="isDashboardCard && !(mobileMode$ | async)" matListItemMeta>
                    {{ notification.createdAt | legfiDate: 'MM/DD' }}
                </span>
            </mat-list-option>
        </ng-container>
    </cdk-virtual-scroll-viewport>
</mat-selection-list>
